import { Middleware } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import { stopPollingAlertsAction } from '../alerts.slice';

import {
  alertsRulesSlice,
  AlertsRulesState,
  checkCategoryOptionsForAlertsRulesAction,
  clearAllAlertsRulesFiltersAction,
  toggleFilterSelectionForAlertsRulesAction,
  toggleIsAlertRulesFiltersSidebarOpenAction,
  updateFiltersWithNestedItemsForAlertsRulesAction,
} from './alertsRules.slice';

interface MiddlewareActions {
  stopPolling: () => void;
}

export const alertsRulesMiddleware: Middleware = (api) => (next) => (action) => {
  const result = next(action);
  const alertsRulesState = api.getState()?.[alertsRulesSlice.name];
  const stopPolling = () => api.dispatch(stopPollingAlertsAction());

  if (alertsRulesState) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // NOTE: Middleware is executed AFTER given action
    alertsRulesMiddlewares[action?.type]?.(alertsRulesState, { stopPolling });
  }

  return result;
};

const alertsRulesMiddlewares = {
  [toggleIsAlertRulesFiltersSidebarOpenAction.type]: (state: AlertsRulesState) => {
    appStorage.setIsAlertRulesFiltersSidebarOpen(state.isAlertRulesFiltersSidebarOpen);
  },
  [toggleFilterSelectionForAlertsRulesAction.type]: (_state: AlertsRulesState, { stopPolling }: MiddlewareActions) => {
    stopPolling();
  },
  [checkCategoryOptionsForAlertsRulesAction.type]: (_state: AlertsRulesState, { stopPolling }: MiddlewareActions) => {
    stopPolling();
  },
  [updateFiltersWithNestedItemsForAlertsRulesAction.type]: (
    _state: AlertsRulesState,
    { stopPolling }: MiddlewareActions,
  ) => {
    stopPolling();
  },
  [clearAllAlertsRulesFiltersAction.type]: (_state: AlertsRulesState, { stopPolling }: MiddlewareActions) => {
    stopPolling();
  },
};
